import '@mdi/font/css/materialdesignicons.css'
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
      iconfont: 'mdi'
    },
    theme: {
      themes: {
        light: {
            primary: '#ff2d55',
            secondary: '#24060C',
            accent: '#7ED957',
            error: '#f44336',
            warning: '#ffc107',
            info: '#00bcd4',
						success: '#4caf50',
						gold: '#d4af37',
            cluvi: '#9716f7',
            cluvi2: '#7335BC',
            redlight: '#EA4B4B',
            warning2: "#FFDD76"
        },
          dark: {
              primary: '#ff2d55',
              secondary: '#24060C',
              accent: '#7ED957',
              error: '#f44336',
              warning: '#ffc107',
              info: '#00bcd4',
              success: '#4caf50',
              cluvi: '#9716f7',
              cluvi2: '#7335BC',
              redlight: '#EA4B4B',
          }
      }
    }
});
